import axios from 'axios';
import {
    MSC_FETCH_PLUGINS_REQUEST,
    MSC_FETCH_PLUGINS_RESULT,
    MSC_FETCH_PLUGIN_REQUEST,
    MSC_GET_PLUGIN,
    MSC_GET_CURRENT_PAGE,
    // MSC_GET_PLUGINS_FOR_PRACTICE,
    MSC_PLUGIN_ERROR,
    MSC_SET_FILTER,
    MSC_SET_PIMS_FILTER,
    MSC_SET_CURRENT_PAGE,
    MSC_SET_PLUGIN_ID,
    MSC_SET_INCLUDE_INACTIVE_PLUGINS,
    MSC_SEARCHING_FOR_PLUGINS,
    MSC_SET_EDITMODAL_ACTIVE_PLUGIN,
    MSC_SET_EDITMODAL_ACTIVE_PLUGIN_ID,
    MSC_SET_EDITMODAL_PLUGIN_STATUS,
    MSC_SET_PLUGIN_ISINACTIVE,
    MSC_SET_SELECTED_PLUGIN_DEFAULTVERSION,
    //Plugin Dependencies
    MSC_SET_EDITMODAL_PLUGIN_DEPENDENCIES,
    MSC_REMOVE_EDITMODAL_PLUGIN_DEPENDENCY,
    MSC_RESET_EDITMODAL_PLUGIN_DEPENDENCIES,
    MSC_SOURCESTATE_EDITMODAL_PLUGIN_DEPENDENCIES,
    MSC_RESETSOURCESTATE_EDITMODAL_PLUGIN_DEPENDENCIES,
    MSC_SET_EDITMODAL_PIMS_DEPENDENCIES,
    MSC_REMOVE_EDITMODAL_PIMS_DEPENDENCY,
    MSC_RESET_EDITMODAL_PIMS_DEPENDENCIES,
    MSC_SOURCESTATE_EDITMODAL_PIMS_DEPENDENCIES,
    MSC_RESETSOURCESTATE_EDITMODAL_PIMS_DEPENDENCIES,
    MSC_SET_EDITMODAL_PLUGIN_VERSION,
    MSC_UPDATE_EDITMODAL_PLUGIN_VERSION,
    MSC_REMOVE_EDITMODAL_PLUGIN_VERSION,
    MSC_RESET_EDITMODAL_PLUGIN_VERSION,
    MSC_SOURCESTATE_EDITMODAL_PLUGIN_VERSION,
    MSC_RESETSOURCESTATE_EDITMODAL_PLUGIN_VERSION,
} from '../ActionTypes';

const initActions = function (services) {
    const axiosCall = services.axios.Axios();

    const searchingForPlugins = (value) => {
        return {
            type: MSC_SEARCHING_FOR_PLUGINS,
            payload: value,
        };
    };

    const getCurrentPage = (currentPage) => {
        return {
            type: MSC_GET_CURRENT_PAGE,
            payload: currentPage,
        };
    };

    const setCurrentPage = (currentPage) => {
        return {
            type: MSC_SET_CURRENT_PAGE,
            payload: currentPage,
        };
    };

    const setFilter = (filter) => {
        return {
            type: MSC_SET_FILTER,
            payload: filter,
        };
    };

    const setPimsFilter = (pimsfilter) => {
        return {
            type: MSC_SET_PIMS_FILTER,
            payload: pimsfilter,
        };
    };

    const setIncludeInactivePlugins = (value = false) => {
        return {
            type: MSC_SET_INCLUDE_INACTIVE_PLUGINS,
            payload: value,
        };
    };

    const fetchPluginRequest = () => {
        return {
            type: MSC_FETCH_PLUGIN_REQUEST,
        };
    };

    const fetchPluginsRequest = () => {
        return {
            type: MSC_FETCH_PLUGINS_REQUEST,
        };
    };

    const fetchPluginsResult = (plugins, pluginTotalPages) => {
        return {
            type: MSC_FETCH_PLUGINS_RESULT,
            payload: { plugins, pluginTotalPages },
        };
    };

    const pluginError = (error) => {
        return {
            type: MSC_PLUGIN_ERROR,
            payload: error,
        };
    };

    const setCurrentPluginId = (id) => {
        return {
            type: MSC_SET_PLUGIN_ID,
            payload: id,
        };
    };

    const setCurrentPlugin = (plugin = {}) => {
        return {
            type: MSC_GET_PLUGIN,
            payload: plugin,
        };
    };

    const getPlugin = (id) => async () => {
        return axiosCall.get('missioncontrol/plugins/' + id);
    };

    var cancelSinglePluginRequest;
    const fetchPlugin = (pluginId) => {
        return async (dispatch) => {
            try {
                //cancel requests if necessary (should aid in unnecessary queries)
                if (cancelSinglePluginRequest !== undefined) {
                    cancelSinglePluginRequest();
                }

                dispatch(fetchPluginRequest);

                var response = await axiosCall.get(
                    `missioncontrol/plugins/${pluginId}`,
                    {
                        cancelToken: new CancelToken(function executor(c) {
                            cancelSinglePluginRequest = c;
                        }),
                    }
                );

                // TODO: put in better error handling
                const plugin = response?.data?.data;
                dispatch(setCurrentPluginId(plugin?.id));
                dispatch(setCurrentPlugin(plugin));

                return plugin;
            } catch (error) {
                const errorMsg = error.message;
                dispatch(pluginError(errorMsg));
            }
        };
    };

    var CancelToken = axios.CancelToken;
    var cancelPluginsRequest;

    const fetchPlugins = (pageNumber = 1, filter = '') => {
        return async (dispatch) => {
            try {
                dispatch(fetchPluginsRequest());

                let route = 'missioncontrol/plugins';
                let request = `pageNumber=${pageNumber}`;
                request += `&filter=${filter}`;

                //cancel requests if necessary (should aid in unnecessary queries)
                if (cancelPluginsRequest !== undefined) {
                    cancelPluginsRequest();
                }
                var response = await axiosCall.get(`${route}?${request}`, {
                    cancelToken: new CancelToken(function executor(c) {
                        cancelPluginsRequest = c;
                    }),
                });
                const plugins = response.data.data.items;
                const totalPages = response.data.data.pluginTotalPages;

                dispatch(fetchPluginsResult(plugins, totalPages));
            } catch (error) {
                const errorMsg = error.message;
                dispatch(pluginError(errorMsg));
            }
        };
    };

    const getPlugins =
        (
            includeTestPlugins = false,
            includeInactivePlugins = false,
            filter = '',
            pimsFilter = ''
        ) =>
        async () => {
            let params = {};
            if (filter !== '') params.pluginfilter = filter;
            if (pimsFilter !== '') params.pimsFilter = pimsFilter;
            if (includeTestPlugins === true) params.includeTestPlugins = true;
            if (includeInactivePlugins === true)
                params.includeInactivePlugins = true;

            //cancel requests if necessary (should aid in unnecessary queries)
            if (cancelPluginsRequest !== undefined) {
                cancelPluginsRequest();
            }
            return axiosCall.get('missionControl/plugins', { params });
        };

    const getAllPlugins =
        (filter = '') =>
        async () => {
            let params = {};
            if (filter !== '') params.filter = filter;

            //cancel requests if necessary (should aid in unnecessary queries)
            if (cancelPluginsRequest !== undefined) {
                cancelPluginsRequest();
            }

            return axiosCall.get('missioncontrol/plugins', { params });
        };

    const getPluginsByOffering = (offering) => async () => {
        //cancel requests if necessary (should aid in unnecessary queries)
        if (cancelPluginsRequest !== undefined) {
            cancelPluginsRequest();
        }

        return axiosCall.get('missioncontrol/plugins/offering/', {
            params: { offering: offering },
        });
    };

    const getActivePlugins = () => async () => {
        try {
            var response = await axiosCall.get('missioncontrol/plugins/active');
            return response.data;
        } catch (err) {
            console.error(err);
        }
    };

    const getActiveNonOfferingPlugins = (offering) => async () => {
        try {
            var response = await axiosCall.get(
                'missioncontrol/plugins/active/nonoffering/',
                { params: { offering: offering } }
            );
            return response.data;
        } catch (err) {
            console.error(err);
        }
    };

    const getPluginVersions = (pluginId) => async () => {
        try {
            var response = await axiosCall.get(
                'missioncontrol/plugins/versions/' + pluginId
            );
            return response.data;
        } catch (err) {
            console.error(err);
        }
    };

    const getPluginVersionById = (id) => async () => {
        try {
            var response = await axiosCall.get(
                'missioncontrol/plugins/version/' + id
            );
            return response.data;
        } catch (err) {
            console.error(err);
        }
    };

    const getPluginDependencies = (pluginId) => async () => {
        try {
            var response = await axiosCall.get(
                'missioncontrol/plugins/dependencies/' + pluginId
            );
            return response.data;
        } catch (err) {
            console.error(err);
        }
    };

    const getPluginDependenciesPlugins = (pluginId) => async () => {
        try {
            var response = await axiosCall.get(
                'missioncontrol/plugins/dependencies/plugins/' + pluginId
            );
            return response.data;
        } catch (err) {
            console.error(err);
        }
    };

    const getPluginDependenciesPims = (pluginId) => async () => {
        try {
            var response = await axiosCall.get(
                'missioncontrol/plugins/dependencies/pims/' + pluginId
            );
            return response.data;
        } catch (err) {
            console.error(err);
        }
    };

    ///////////////////////////
    //Create & Edit Plugin
    ///////////////////////////
    const setEditModalPluginStatus = (status) => {
        if (!status)
            status = {
                detailPlugin: false,
                addNewPlugin: false,
                addDependencies: false,
                editingPlugin: false,
                editingVersions: false,
            };
        return {
            type: MSC_SET_EDITMODAL_PLUGIN_STATUS,
            payload: status,
        };
    };

    const setPluginIsInactive = (isInactive) => {
        return {
            type: MSC_SET_PLUGIN_ISINACTIVE,
            payload: isInactive,
        };
    };

    //#region Plugin Dependencies
    const resetPluginDependencies = (pluginDependencies = []) => {
        return {
            type: MSC_RESET_EDITMODAL_PLUGIN_DEPENDENCIES,
            payload: pluginDependencies,
        };
    };

    const setPluginDependencies = (pluginDependencies) => {
        return {
            type: MSC_SET_EDITMODAL_PLUGIN_DEPENDENCIES,
            payload: pluginDependencies,
        };
    };

    const setSourcePluginDependencies = (pluginDependencies) => {
        return {
            type: MSC_SOURCESTATE_EDITMODAL_PLUGIN_DEPENDENCIES,
            payload: pluginDependencies,
        };
    };

    const resetSourcePluginDependencies = (sourcepluginDependencies = []) => {
        return {
            type: MSC_RESETSOURCESTATE_EDITMODAL_PLUGIN_DEPENDENCIES,
            payload: sourcepluginDependencies,
        };
    };

    const removePluginDependency = (pluginName) => {
        return {
            type: MSC_REMOVE_EDITMODAL_PLUGIN_DEPENDENCY,
            payload: pluginName,
        };
    };

    const resetPimsDependencies = (pimsDependencies = []) => {
        return {
            type: MSC_RESET_EDITMODAL_PIMS_DEPENDENCIES,
            payload: pimsDependencies,
        };
    };

    const setPimsDependencies = (pimsDependencies) => {
        //we have to handle from api
        return {
            type: MSC_SET_EDITMODAL_PIMS_DEPENDENCIES,
            payload: pimsDependencies,
        };
    };

    const setSourcePimsDependencies = (pimsDependencies) => {
        return {
            type: MSC_SOURCESTATE_EDITMODAL_PIMS_DEPENDENCIES,
            payload: pimsDependencies,
        };
    };

    const resetSourcePimsDependencies = (sourcepimsDependencies = []) => {
        return {
            type: MSC_RESETSOURCESTATE_EDITMODAL_PIMS_DEPENDENCIES,
            payload: sourcepimsDependencies,
        };
    };

    const removePimsDependency = (pimsData) => {
        return {
            type: MSC_REMOVE_EDITMODAL_PIMS_DEPENDENCY,
            payload: pimsData,
        };
    };

    const resetPluginVersions = (version = []) => {
        return {
            type: MSC_RESET_EDITMODAL_PLUGIN_VERSION,
            payload: version,
        };
    };

    const setPluginVersions = (versions) => {
        //we have to handle from api
        return {
            type: MSC_SET_EDITMODAL_PLUGIN_VERSION,
            payload: versions,
        };
    };

    const setSourcePluginVersions = (pluginVersions) => {
        return {
            type: MSC_SOURCESTATE_EDITMODAL_PLUGIN_VERSION,
            payload: pluginVersions,
        };
    };

    const resetSourcePluginVersions = (sourcepluginVersions = []) => {
        return {
            type: MSC_RESETSOURCESTATE_EDITMODAL_PLUGIN_VERSION,
            payload: sourcepluginVersions,
        };
    };

    const updatePluginVersion = (version) => {
        return {
            type: MSC_UPDATE_EDITMODAL_PLUGIN_VERSION,
            payload: version,
        };
    };

    const removePluginVersion = (version) => {
        return {
            type: MSC_REMOVE_EDITMODAL_PLUGIN_VERSION,
            payload: version,
        };
    };
    //#endregion

    const setEditModalCurrentPlugin = (plugin) => {
        return {
            type: MSC_SET_EDITMODAL_ACTIVE_PLUGIN,
            payload: plugin,
        };
    };

    const setEditModalCurrentPluginId = (id) => {
        return {
            type: MSC_SET_EDITMODAL_ACTIVE_PLUGIN_ID,
            payload: id,
        };
    };

    const setSelectedPluginDefaultVersion = (defaultVersion) => {
        return {
            type: MSC_SET_SELECTED_PLUGIN_DEFAULTVERSION,
            payload: defaultVersion,
        };
    };

    const addOrUpdatePlugin = (plugin) => async () => {
        try {
            await axiosCall.put('MissionControl/plugin', plugin);
            return {
                isSuccess: true,
                message: 'Plugin update succeeded!',
            };
        } catch (error) {
            return {
                isSuccess: false,
                message: 'Plugin update failed!',
            };
        }
    };

    const addPluginToOffering = (pluginId, offeringName) => async () => {
        try {
            const endpoint = `MissionControl/plugins/offering?offeringName=${offeringName}&pluginId=${pluginId}`;
            const response = await axiosCall.post(endpoint);
            return {
                payload: {
                    pluginId: pluginId,
                    offeringName: offeringName,
                    offeringId: response,
                },
            };
        } catch (error) {
            return {
                isSuccess: false,
                message: 'Failed to add plugin to offering!',
            };
        }
    };

    const removePluginFromOffering = (pluginId, offeringName) => async () => {
        try {
            const endpoint = `MissionControl/plugins/offering?offeringName=${offeringName}&pluginId=${pluginId}`;
            const response = await axiosCall.delete(endpoint);
            return {
                payload: {
                    pluginId: pluginId,
                    offeringName: offeringName,
                    offeringId: response,
                },
            };
        } catch (error) {
            return {
                isSuccess: false,
                message: 'Failed to remove plugin from offering!',
            };
        }
    };

    const fetchMissionControlVersions = () => async () => {
        try {
            const response = await axiosCall.get(
                'MissionControl/missionControlVersion/all'
            );
            return response.data;
        } catch (err) {
            console.error(err);
        }
    };

    const fetchDefaultMissionControlVersion = () => async () => {
        try {
            const response = await axiosCall.get(
                'MissionControl/missionControlVersion/default'
            );
            return response.data;
        } catch (err) {
            console.error(err);
        }
    };

    const setDefaultMissionControlVersion = (version) => {
        return async () => {
            try {
                await axiosCall.patch(
                    `MissionControl/missionControlVersion/default?versionString=${version}`
                );
                return {
                    isSuccess: true,
                    message: 'Default Mission Control version updated!',
                };
            } catch (err) {
                console.error(err);
                return {
                    isSuccess: false,
                    message:
                        'Failed to update default Mission Control version!',
                };
            }
        };
    };

    return {
        fetchPluginRequest,
        fetchPluginsRequest,
        fetchPluginsResult,
        fetchPlugins,
        fetchPlugin,
        getCurrentPage,
        getAllPlugins,
        getPluginsByOffering,
        getActivePlugins,
        getActiveNonOfferingPlugins,
        getPlugins,
        getPlugin,
        getPluginVersions,
        getPluginVersionById,
        getPluginDependencies,
        getPluginDependenciesPlugins,
        getPluginDependenciesPims,
        setFilter,
        setPimsFilter,
        searchingForPlugins,
        setCurrentPage,
        setCurrentPluginId,
        setCurrentPlugin,
        setIncludeInactivePlugins,
        setPluginIsInactive,
        setSelectedPluginDefaultVersion,
        setPluginDependencies,
        setPimsDependencies,
        setSourcePluginDependencies,
        setSourcePimsDependencies,
        setSourcePluginVersions,
        setPluginVersions,
        setEditModalCurrentPlugin,
        setEditModalCurrentPluginId,
        setEditModalPluginStatus,
        removePluginDependency,
        removePimsDependency,
        removePluginVersion,
        resetPluginDependencies,
        resetPimsDependencies,
        resetPluginVersions,
        resetSourcePluginDependencies,
        resetSourcePimsDependencies,
        resetSourcePluginVersions,
        updatePluginVersion,
        pluginError,
        addOrUpdatePlugin,
        addPluginToOffering,
        removePluginFromOffering,
        fetchMissionControlVersions,
        fetchDefaultMissionControlVersion,
        setDefaultMissionControlVersion,
    };
};

export default initActions;
